import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  body?: string;
  action?: ReactNode;
  tone?: 'neutral' | 'success' | 'attention';
}

const TONE: Record<NonNullable<EmptyStateProps['tone']>, { border: string; background: string }> = {
  neutral: { border: 'var(--border)', background: 'var(--surface-raised)' },
  success: { border: 'var(--sev-healthy)', background: 'var(--sev-healthy-bg)' },
  attention: { border: 'var(--sev-attention)', background: 'var(--sev-attention-bg)' },
};

export function EmptyState({ title, body, action, tone = 'neutral' }: EmptyStateProps) {
  const colors = TONE[tone];
  return (
    <section
      role="status"
      aria-live="polite"
      style={{
        padding: 18,
        border: `1px solid ${colors.border}`,
        borderRadius: 'var(--r-lg, 14px)',
        background: colors.background,
        color: 'var(--text, #1B1D22)',
      }}
    >
      <div className="v-h3" style={{ marginBottom: body ? 6 : 0 }}>{title}</div>
      {body && <p className="v-caption" style={{ margin: 0 }}>{body}</p>}
      {action && <div style={{ marginTop: 14 }}>{action}</div>}
    </section>
  );
}
